(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var navbar = document.querySelector('.ai-hero__navbar-header');
    if (!navbar) return;

    /* =====================================================
       SCROLL BEHAVIOUR
       ===================================================== */
    function handleScroll() {
      var scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;

      if (scrollPosition > 20) {
        navbar.classList.add('is-scrolled');
      } else {
        navbar.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    /* =====================================================
       MOBILE MENU
       ===================================================== */
    var mobileMenu = navbar.querySelector('.ai-hero__mobile-menu');
    var menuButton = navbar.querySelector('.ai-hero__mobile-menu-button');
    var closeButton = navbar.querySelector('.ai-hero__mobile-menu-close');

    if (!mobileMenu || !menuButton || !closeButton) return;

    function openMobileMenu() {
      mobileMenu.classList.add('is-open');
      navbar.classList.add('mobile-menu-open');

      menuButton.setAttribute('aria-expanded', 'true');
      menuButton.setAttribute('aria-label', 'Close menu');

      mobileMenu.setAttribute('aria-hidden', 'false');

      document.body.classList.add('ai-mobile-menu-open');
    }

    function closeMobileMenu() {
      mobileMenu.classList.remove('is-open');
      navbar.classList.remove('mobile-menu-open');

      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');

      mobileMenu.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('ai-mobile-menu-open');

      var expandedItems = mobileMenu.querySelectorAll('.ai-hero__mobile-menu-item.is-expanded');
      expandedItems.forEach(function (item) {
        item.classList.remove('is-expanded');
        var toggle = item.querySelector('[data-mobile-dropdown-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    menuButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      closeMobileMenu();
    });

    mobileMenu.addEventListener('click', function (event) {
      if (event.target === mobileMenu) {
        closeMobileMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMobileMenu();
      }
    });

    /* =====================================================
       MOBILE DROPDOWN ACCORDIONS
       ===================================================== */
    var mobileDropdownToggles = mobileMenu.querySelectorAll('[data-mobile-dropdown-toggle]');

    mobileDropdownToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var menuItem = toggle.closest('.ai-hero__mobile-menu-item');
        if (!menuItem) return;

        var isExpanded = menuItem.classList.contains('is-expanded');

        var otherItems = mobileMenu.querySelectorAll('.ai-hero__mobile-menu-item.is-expanded');
        otherItems.forEach(function (otherItem) {
          if (otherItem !== menuItem) {
            otherItem.classList.remove('is-expanded');
            var otherToggle = otherItem.querySelector('[data-mobile-dropdown-toggle]');
            if (otherToggle) {
              otherToggle.setAttribute('aria-expanded', 'false');
            }
          }
        });

        if (isExpanded) {
          menuItem.classList.remove('is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          menuItem.classList.add('is-expanded');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var mobileLinks = mobileMenu.querySelectorAll(
      '.ai-hero__mobile-menu-link:not([data-mobile-dropdown-toggle]), .ai-hero__mobile-submenu-link'
    );

    mobileLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        closeMobileMenu();
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 989) {
        closeMobileMenu();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
